import styled from "styled-components";

export const StyledButton = styled("button")<{ color?: string }>`
  background: ${(p) => p.color || "#1277ae"};  /* Update to the new button color */
  color: ${(p) => (p.color ? "#073b58" : "#fff")};  /* Update to the new text color */
  font-size: 1rem;
  font-weight: 700;
  width: 100%;
  border: 1px solid #edf3f5;
  border-radius: 4px;
  padding: 13px 0;
  cursor: pointer;
  margin-top: 0.625rem;
  max-width: 180px;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 16px 30px rgb(23 31 114 / 20%);

  &:hover,
  &:active,
  &:focus {
    color: #fff;  /* Keep text color white on hover */
    background-color: #358eda;  /* Update to the new hover blue color */
    border: 1px solid #358eda;  /* Match border with hover color */
  }
`;
